import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useUserProfile } from "@/hooks/useUserProfile";

export interface PortalClient {
  id: string;
  name: string;
  code: string | null;
}

/**
 * The clients (brands) the signed-in customer-portal login can see, from
 * portal_client_access. One login can manage several brands. Empty for staff.
 */
export function useMyPortalClients() {
  const { data: profile } = useUserProfile();
  const userAccountId = profile?.id;

  return useQuery({
    queryKey: ["my-portal-clients", userAccountId],
    enabled: !!userAccountId,
    queryFn: async (): Promise<PortalClient[]> => {
      const { data, error } = await supabase
        .from("portal_client_access")
        .select("client:client_id(id, name, code)")
        .eq("user_account_id", userAccountId!);
      if (error) throw error;

      return (data ?? [])
        .map((row) => row.client as PortalClient | null)
        .filter((c): c is PortalClient => !!c)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  });
}
